import React, { MouseEventHandler } from "react";
import { ReactComponent as SappchatIcon } from "assets/sappchat-logo.svg";
import styled from "styled-components";
interface ISappchatLogo {
  logoText: boolean;
  logoWidth?: number;
  logoHeight?: number;
  handleClick: MouseEventHandler<HTMLDivElement>;
  styleIcon?: Object;
}

const SappchatLogo = ({
  logoText,
  logoWidth,
  logoHeight,
  handleClick,
  styleIcon,
}: ISappchatLogo) => {
  return (
    <SappchatLogoDiv onClick={handleClick}>
      <SappchatIcon
        width={logoWidth || 24}
        height={logoHeight || 24}
        style={styleIcon}
      />

      {logoText && <LogoText>Sappchat</LogoText>}
    </SappchatLogoDiv>
  );
};

export default SappchatLogo;

const LogoText = styled.span`
    margin-left: 1rem;
    color: #fff;  
    font-size: 1.5rem;
    font-weight: 600;

    /* @media (max-width: 1024px){
      display: none;
    } */
`;

const SappchatLogoDiv = styled.div`
    display: flex; 
    align-items: center;
    cursor: pointer;
`;
